export default __webpack_public_path__ + "static/media/tre-se.cf02ca94.png";